export const REFRESH_PERSON = 'REFRESH_PERSON';
export const REFRESH_HINTS = 'REFRESH_HINTS';
export const REFRESH_RECOMMENDATIONS = 'REFRESH_RECOMMENDATIONS';
